import { getListViewMaxWidth } from './getMaxWidths';
import { isReadingPanePositionRight } from '../selectors/readingPanePosition';
import getColumnMinWidth, { getReceivedColumnMinWidth } from './getColumnMinWidth';
import type MailListColumnHeaderType from '../types/MailListColumnHeaderType';
import { isFeatureEnabled } from 'owa-feature-flags';
import { RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH } from '../mailLayoutConstants';

export function getMLColumnHeaderDefaultWidths(): {
    senderColumnWidth: number;
    subjectColumnWidth: number;
    receivedColumnWidth: number;
} {
    const shouldShowColumnHeaderStyles =
        isFeatureEnabled('tri-mlFocusSelect') && isFeatureEnabled('tri-mlColumnHeaderHover');

    // default width and min width are the same for sender and received columns.
    // since there is no set default width for subject column, keep it as 92 so it never
    // disappears completely.
    const defaultSenderColumnWidth = shouldShowColumnHeaderStyles ? getColumnMinWidth(0) : 192;

    const isReadingPaneRight = isReadingPanePositionRight();

    // Column header width includes content + right padding + left padding + scrollbar space
    // Naming of this file is confusing because Listview implies the actual rows, but the returned widths are for the column headers
    const defaultReceivedColumnWidth: number = shouldShowColumnHeaderStyles
        ? getReceivedColumnMinWidth(true /* isColumnHeader */, isReadingPaneRight)
        : isReadingPaneRight
        ? 124
        : RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH;

    // subject column takes the remaining space
    const defaultSubjectColumnWidth =
        getListViewMaxWidth() - defaultSenderColumnWidth - defaultReceivedColumnWidth;

    return {
        senderColumnWidth: defaultSenderColumnWidth,
        subjectColumnWidth: defaultSubjectColumnWidth,
        receivedColumnWidth: defaultReceivedColumnWidth,
    };
}
